$(() => {
    initializeSpeakerBlocks()
})

function initializeSpeakerBlocks() {
    $(".speakers-focus-container").each(function () {
        new SpeakerCarousel(this);
    });
}

class SpeakerCarousel {

    el: JQuery<HTMLElement>;
    carouselFocusContainerEl: JQuery<HTMLElement>;
    speakerContainerEl: JQuery<HTMLElement>;
    carousel: JQuery<HTMLElement>;
    anchor: string;

    constructor(carouselContainerElement: HTMLElement) {
        this.el = $(carouselContainerElement);
        this.carouselFocusContainerEl = this.el.find('.speaker-focus-carousel-container');
        this.speakerContainerEl = this.el.find('.speakers-focus');
        const self = this;

        this.carousel = this.el.find('.speaker-focus-carousel').slick({
            speed: 300,
            slidesToShow: 1,
            adaptiveHeight: true,
            nextArrow: this.el.find('.arrow-right'),
            prevArrow: this.el.find('.arrow-left')
        });

        this.carousel.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            const element = self.speakerContainerEl.find(`[data-index='${nextSlide}']`);
            location.hash = element.attr("id");
        });

        this.el.find('.speakers-focus-item').each(function () {
            const element = $(this);

            element.on('click', () => {
                self.anchor = element.attr("id");
                history.pushState(null, null, `#${self.anchor}`);
                self.showCarousel(element.data("index"));
                $("html, body").animate({ scrollTop: self.el.offset().top }, 500);
            })
        });


        this.el.find('.close-button button').on("click", () => {
            this.closeCarousel();
            history.pushState(null, null, `#`);
        });

        const currentLocation = location.hash.replace("#", "");

        if (currentLocation.length > 0) {
            this.speakerContainerEl.find(`#${currentLocation}`).trigger("click");
        }
    }


    showCarousel(index: number) {
        this.carousel.slick('slickGoTo', index);
        this.speakerContainerEl.hide();
        this.carouselFocusContainerEl.css("display", "flex");
        this.carousel.slick('refresh');
    }

    closeCarousel() {
        this.carouselFocusContainerEl.hide();
        this.speakerContainerEl.css("display", "flex");
        if (this.anchor) {
            setTimeout(() => {// mandatory for the animation to work properly on Chrome
                document.getElementById(this.anchor).scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
            }, 0);
        }
    }

}